import React from 'react';
import PropTypes from 'prop-types';

import { SimpleSignUpForm } from 'paper/components/SimpleSignUpForm';

import styles from './styles.module.less';

const SimpleSignUp = ({
  closeModal,
  closeCallback,
  onLogIn,
  cardType,
  onExternalSignUp,
  isGuest,
  shouldTrackOnboarding,
}) => {
  return (
    <div className={styles.container}>
      <SimpleSignUpForm
        closeModal={closeModal}
        closeCallback={closeCallback}
        onLogIn={onLogIn}
        businessUnitComponent={cardType}
        onExternalSignUp={onExternalSignUp}
        isGuest={isGuest}
        shouldTrackOnboarding={shouldTrackOnboarding}
      />
    </div>
  );
};

SimpleSignUp.propTypes = {
  closeModal: PropTypes.func,
  closeCallback: PropTypes.func,
  isGuest: PropTypes.bool,
  shouldTrackOnboarding: PropTypes.bool,
  onLogIn: PropTypes.func,
  cardType: PropTypes.string.isRequired,
  onExternalSignUp: PropTypes.func,
};

export default SimpleSignUp;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/SimpleSignUpModal/SimpleSignUpModal.jsx